import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker as DatePickerMUI } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { Control, Controller, FieldPath } from "react-hook-form";
import { TRules } from "types/form.types";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePickerStyled } from "./DateTimePickerForm.style";
import { useTranslation } from "react-i18next";

type TDateVal = string | null;

interface IDatePicker<FormNames extends Record<string, any>> {
  control: Control<FormNames>;
  name: FieldPath<FormNames>;
  rules?: TRules<FormNames>;
  label?: string;
  disableTime?: boolean;
  minDate?: Date;
  maxDate?: Date;
}
const dateRegex = /^(0[1-9]|[1-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-(\d{4})$/;
export const DATE_FORMAT = "DD-MM-YYYY";

function DatePickerForm<FormNames extends Record<string, any>>({
  control,
  name,
  disableTime = false,
  minDate,
  maxDate,
  rules = {
    required: {
      value: true,
      message: "general.required",
    },
    // pattern: disableTime
    //   ? {
    //       value: dateRegex,
    //       message: "Sanani to'g'ri kiriting",
    //     }
    //   : undefined,
    // pattern: {
    //   value:
    // },
    // deps
  },
  label,
}: IDatePicker<FormNames>) {
  const format = disableTime ? DATE_FORMAT : `${DATE_FORMAT}`;
  const { t } = useTranslation();

  return (
    <DateTimePickerStyled>
      <Controller
        control={control}
        name={name}
        rules={rules}
        // @ts-ignores😐
        defaultValue={null}
        render={({ field, fieldState: { error } }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              {...field}
              // ampm={false}
              inputFormat={format}
              minDate={minDate ? minDate : null}
              maxDate={maxDate ? maxDate : null}
              // views={disableTime ? ["year", "month", "day"] : undefined}
              renderInput={(pickerProps) => (
                <>
                  <span className="label">
                    {label}
                    {!!rules.required && <span className="text-error">*</span>}
                  </span>
                  <TextField
                    {...pickerProps}
                    inputProps={{
                      ...pickerProps.inputProps,
                      readOnly: true,
                      placeholder: dayjs().format(format),
                    }}
                    placeholder="oy"
                    // label="Sana"
                    fullWidth
                    sx={{
                      "& fieldset": { border: "none", marginTop: "10px" },
                    }}
                  />
                </>
              )}
            />
            {error && (
              <>
                <h6 className="text-error mt-1">
                  {label} {t(error.message!)}
                </h6>
              </>
            )}
          </LocalizationProvider>
        )}
      />
    </DateTimePickerStyled>
  );
}
export default DatePickerForm;
